import React, { Component } from 'react'
import {Segment,Header,Icon, Divider,Table,Button, Image, List} from"semantic-ui-react"
import RoomInfoContainer from './room_info_container'

export default class ReportViewerContainer extends Component {
    constructor(props) {
      super(props)
    
      this.state = {
        liabilities:undefined,
        copySuccess:false
      }
    }

    componentDidMount() {
      let tenantCost=[]
      let landlordInfo=[]
      let wearAndTear = []
      let itemIndex = 0
          this.props.reportDetails.rooms.map((room) => {
            if (room.images.length > 0) {
            room.images.map((image) => {this.props.addToImagesList(image)})
            }
            room.groups.length > 0 ? room.groups.map((group) => { 
              group.items.length > 0 ? group.items.map((item) => {
                item.images.length>0? item.images.map((image) =>{this.props.addToImagesList(image)}):null;
                itemIndex = itemIndex + 1
                if(this.props.reportDetails.is_co_report) {
                  switch (item.flag) {
                    case 'Wear and Tear':
                      wearAndTear.push({room:room.name,group:group.name,item:item, index:itemIndex})
                      break;
                    case 'Landlord Info':
                      landlordInfo.push({room:room.name,group:group.name,item:item,index:itemIndex})
                      break;
                    case 'Tenant Cost':
                      tenantCost.push({room:room.name,group:group.name,item:item,index:itemIndex})
                      break;
                  }
                  item.additional_co_notes.map( note => {
                    switch (note.flag) {
                      case 'Wear and Tear':
                        wearAndTear.push({room:room.name,group:group.name,item:{...note,name:item.name}, index:itemIndex})
                        break;
                      case 'Landlord Info':
                        landlordInfo.push({room:room.name,group:group.name,item:{...note,name:item.name},index:itemIndex})
                        break;
                      case 'Tenant Cost':
                        tenantCost.push({room:room.name,group:group.name,item:{...note,name:item.name},index:itemIndex})
                        break;
                    }
                  })
                }
              }) :null
            }):null      
          })
          this.setState({liabilities:{tenantCost:tenantCost,landlordInfo:landlordInfo,wearAndTear:wearAndTear}})
      }
      copyLiability = (liability) =>{
        let liabilities = []
        switch (liability) {
          case 'tc':
            liabilities = this.state.liabilities.tenantCost 
          break;
          case 'fwt':
            liabilities = this.state.liabilities.wearAndTear 
          break;
          case 'llinfo':
            liabilities = this.state.liabilities.landlordInfo 
          break;
        }
        let copyString = ""
        liabilities.map((entry) => {
          copyString += `${entry.index} - ${entry.room} - ${entry.group} - ${entry.item.name} - ${entry.item.co_notes}\n`
        })
        navigator.clipboard.writeText(copyString)
        .then(() => {
          this.setState({copySuccess:true});
          setTimeout(() => {
            this.setState({copySuccess:false});
          }, 3000);
        })
        .catch((error) => {
          console.error('Failed to copy text:', error);
        });
      }
      followFlag = (flag) =>{
        let trimmedFlag = flag.replace(/\s+/g, "")
        const anchor = document.querySelector(`#${trimmedFlag}`);
        anchor.scrollIntoView({ behavior: "smooth", block: 'center' });
      }
 
  render() {
    let itemIndex = 0
    return (
        <React.Fragment><div className="nested-segment">
          <Segment  style={{width:"50%",margin:"auto"}}>
            <Header as="h2">Table of Contents</Header>
            <List bulleted selection verticalAlign='middle'>
            <List.Item className="rvListItem"onClick={()=>{this.followFlag("generaldetails")}}>
              General Details
            </List.Item>
            <List.Item className="rvListItem"onClick={()=>{this.followFlag("generaldetailsmeters")}}>
              Meters
            </List.Item>
            {this.props.reportDetails.rooms.map((room,index)=>{
            return <List.Item key={room.client_id} className="rvListItem" onClick={()=>{this.followFlag(`room${index}`)}}>
            {room.name}
          </List.Item>
            })}
            {this.props.reportDetails.is_co_report && this.state.liabilities && this.state.liabilities.tenantCost.length > 0 && <List.Item className="rvListItem"onClick={()=>{this.followFlag("TenantCost")}}>
              Summary of Dilapidations - Tenant Cost
            </List.Item>}
            {this.props.reportDetails.is_co_report && this.state.liabilities && this.state.liabilities.wearAndTear.length > 0 && <List.Item className="rvListItem"onClick={()=>{this.followFlag("WearandTear")}}>
              Summary of Dilapidations - Fair Wear and Tear
            </List.Item>}
            {this.props.reportDetails.is_co_report && this.state.liabilities && this.state.liabilities.landlordInfo.length > 0 && <List.Item className="rvListItem" onClick={()=>{this.followFlag("LandlordInfo")}}>
              Summary of Dilapidations - Landlord Information
            </List.Item>}
            </List>
            </Segment>
            <Divider horizontal><Header as='h2'><Icon name='home' />Rooms</Header></Divider>

        {this.props.reportDetails.rooms.map((room, index) =>{ 
          return <React.Fragment key={`${room.client_id}${index}`}><Header id={`room${index}`}className="nested-segment" as="h3" attached="top">
            <Header.Content>{room.name}<Button onClick={()=>{this.followFlag("top")}}compact basic >Back to Top</Button></Header.Content> 
  </Header>
  {room.images.length > 0  &&  <React.Fragment key={room.client_id}><Segment attached className="nested-segment"><Header className="nested-segment" as="h3" attached="top">
            <Header.Content>General View Images</Header.Content> 
  </Header>
  <Segment attached className="nested-segment">
  <Image.Group size="small">
                                  { room.images.map((image) => {
                                          return ( 
                                                  <Image key={image.id}
                                                      style={{ cursor: "pointer" }}
                                                      className="grow"
                                                      onClick={() => {this.props.setCurrentImage(image)
                                                      }}
                                                      rounded
                                                      src={image.image_path}
                                                      target="_blank"
                                                  />)}
   )}</Image.Group></Segment></Segment></React.Fragment>}
  <Segment attached className="nested-segment">
  {room.groups.map((group) =>{return <React.Fragment key={group.client_id}><Header className="nested-segment" as="h3" attached="top">
            <Header.Content>{group.name} <Button onClick={()=>{this.followFlag("top")}}compact basic >Back to Top</Button></Header.Content> 
  </Header>
  <Segment attached className="nested-segment">
  <Table unstackable celled structured striped>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell collapsing>Ref.</Table.HeaderCell>
        <Table.HeaderCell>Item Name</Table.HeaderCell>
        <Table.HeaderCell>Check In Notes</Table.HeaderCell>
        {this.props.reportDetails.is_co_report &&<Table.HeaderCell>Check Out Notes</Table.HeaderCell>}
        <Table.HeaderCell collapsing><div style={{textAlign:"center"}}><Icon name="photo" ></Icon></div></Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>{group.items.map((item) =>{ itemIndex += 1; return<React.Fragment key={item.client_id}><Table.Row>
        <Table.Cell textAlign="center" rowSpan = {item.images.length > 0 ? 2:1} width={1}>{itemIndex}</Table.Cell>
        <Table.Cell width={5}><strong>{item.name}</strong></Table.Cell>
        <Table.Cell width={this.props.reportDetails.is_co_report? 5 : 10}>{item.ci_notes}</Table.Cell>
        {this.props.reportDetails.is_co_report && <Table.Cell width={5}>{(item.co_notes && item.co_notes.trim() != "") ? <React.Fragment><span>{item.co_notes} {item.flag !="None" && item.flag !=undefined && <Button compact onClick={()=>{this.followFlag(item.flag)}} basic color="grey" size="mini"><strong>{item.flag} {item.flag == "Tenant Cost" && <span>- {item.tenant_cost_category? item.tenant_cost_category:"OTHER"}</span>}</strong></Button>}</span>
        {item.additional_co_notes.map((note) =>{return <React.Fragment key={note.id}><Divider/>
        <span>{note.co_notes} <Button onClick={()=>{this.followFlag(note.flag)}} compact basic color="grey" size="mini"><strong>{note.flag} {note.flag == "Tenant Cost" && <span>- {note.tenant_cost_category? note.tenant_cost_category:"OTHER"}</span>}</strong></Button></span>
        </React.Fragment>})}</React.Fragment>:<span>{this.props.reportDetails.report_type=="other"?"As Original Report" : "✔"}</span>}</Table.Cell>}
        <Table.Cell width={1}><Button compact basic size="mini">{item.images.length}</Button></Table.Cell>
      </Table.Row>
      {item.images.length > 0 && <Table.Row>
        <Table.Cell colspan={4}>
        <Image.Group size="small">
                                  {item.images.length > 0 ? item.images.map((image) => {
                                          return ( 
                                                  <Image
                                                  key={image.id}
                                                      style={{ cursor: "pointer" }}
                                                      className="grow"
                                                      onClick={() => {this.props.setCurrentImage(image)
                                                      }}
                                                      rounded
                                                      src={image.image_path}
                                                      target="_blank"
                                                  />)}
   ) : null}
                      </Image.Group>
        </Table.Cell>
      </Table.Row> }

      </React.Fragment>})
  }        </Table.Body></Table>
            {this.props.reportDetails.inspection.additional_images.some(image => image.image_type ==group.client_id) && <Segment>
              <Header attached="top" as="h3" ><strong>Additional Group Images</strong> </Header>
                 <Segment attached="bottom"><Image.Group size="small">
                    {this.props.reportDetails.inspection.additional_images
                      .filter(image => image.image_type === group.client_id)
                      .map((image, index) => (
                        <Image
                         style={{ cursor: "pointer" }}
                          className="grow"
                          onClick={() => {this.props.setCurrentImage(image)
                          }}
                          rounded
                          src={image.image_path}
                          target="_blank"
                          key={index}
                        />
                      ))}
                  </Image.Group></Segment>
              </Segment>}
    </Segment></React.Fragment>})}
          {this.props.reportDetails.inspection.additional_images.some(image => image.image_type ==room.client_id) && <Segment>
              <Header attached="top" as="h3" ><strong>Additional Room Images</strong> </Header>
                 <Segment attached="bottom"><Image.Group size="small">
                    {this.props.reportDetails.inspection.additional_images
                      .filter(image => image.image_type === room.client_id)
                      .map((image, index) => (
                        <Image
                         style={{ cursor: "pointer" }}
                          className="grow"
                          onClick={() => {this.props.setCurrentImage(image)
                          }}
                          rounded
                          src={image.image_path}
                          target="_blank"
                          key={index}
                        />
                      ))}
                  </Image.Group></Segment>
              </Segment>}
    </Segment></React.Fragment>})}</div>
  <Divider/>
  {this.props.reportDetails.is_co_report && this.state.liabilities &&<React.Fragment>
    {this.state.liabilities.tenantCost.length > 0 && <React.Fragment><Header id="TenantCost" className="nested-segment" as="h3" attached="top">
    <Header.Content>Liability Summary - Tenant Cost <Button compact style={{marginLeft:"5px"}} disabled={this.state.copySuccess} onClick={()=> this.copyLiability("tc")} primary>{!this.state.copySuccess? "Copy To Clipboard":"Copy Successful"}</Button><Button onClick={()=>{this.followFlag("top")}}compact basic >Back to Top</Button></Header.Content> 
    </Header>
    <Segment attached className="nested-segment">
      <Table>
        <Table.Header><Table.Row>
          <Table.HeaderCell collapsing>Ref</Table.HeaderCell>
          <Table.HeaderCell>Room</Table.HeaderCell>
          <Table.HeaderCell>Group</Table.HeaderCell>
          <Table.HeaderCell>Item </Table.HeaderCell>
          <Table.HeaderCell>Check Out Notes</Table.HeaderCell>
          </Table.Row></Table.Header>
          <Table.Body>
            {this.props.reportDetails.additional_summary_detail && this.props.reportDetails.additional_summary_detail.tenant_cost_summary && <Table.Row>
              <Table.Cell colspan={3}><strong>General Note</strong></Table.Cell>
              <Table.Cell colspan={2}>{this.props.reportDetails.additional_summary_detail.tenant_cost_summary}</Table.Cell>
              </Table.Row>}
              {this.props.reportDetails.inspection.additional_images.some(image => image.image_type =="tenant_cost") && <Table.Row>
              <Table.Cell colspan={3}><strong>General Note Images</strong></Table.Cell>
              <Table.Cell colspan={2}>
                 <Image.Group size="small">
                    {this.props.reportDetails.inspection.additional_images
                      .filter(image => image.image_type === "tenant_cost")
                      .map((image, index) => (
                        <Image
                         style={{ cursor: "pointer" }}
                          className="grow"
                          onClick={() => {this.props.setCurrentImage(image)
                          }}
                          rounded
                          src={image.image_path}
                          target="_blank"
                          key={index}
                        />
                      ))}
                  </Image.Group>
              </Table.Cell>
              </Table.Row>}
        { this.state.liabilities.tenantCost.map(entry =>{
          return <Table.Row>
          <Table.Cell>{entry.index}</Table.Cell>
          <Table.Cell>{entry.room}</Table.Cell>
          <Table.Cell>{entry.group}</Table.Cell>
          <Table.Cell>{entry.item.name}</Table.Cell>
          <Table.Cell>{entry.item.co_notes}</Table.Cell>
        </Table.Row>
        })}
          </Table.Body>
      </Table>
    </Segment></React.Fragment>}

    {this.state.liabilities.wearAndTear.length > 0 && <React.Fragment><Header id="WearandTear" className="nested-segment" as="h3" attached="top">
    <Header.Content>Liability Summary - Fair Wear and Tear <Button onClick={()=> this.copyLiability("fwt")} primary compact style={{marginLeft:"5px"}}>Copy To Clipboard</Button><Button onClick={()=>{this.followFlag("top")}}compact basic >Back to Top</Button></Header.Content> 
    </Header>
    <Segment attached className="nested-segment">
      <Table>
        <Table.Header><Table.Row>
          <Table.HeaderCell collapsing>Ref</Table.HeaderCell>
          <Table.HeaderCell>Room</Table.HeaderCell>
          <Table.HeaderCell>Group</Table.HeaderCell>
          <Table.HeaderCell>Item </Table.HeaderCell>
          <Table.HeaderCell>Check Out Notes</Table.HeaderCell>
          </Table.Row></Table.Header>
          <Table.Body>
           {this.props.reportDetails.additional_summary_detail && this.props.reportDetails.additional_summary_detail.wear_and_tear_summary && <Table.Row>
              <Table.Cell colspan={3}><strong>General Note</strong></Table.Cell>
              <Table.Cell colspan={2}>{this.props.reportDetails.additional_summary_detail.wear_and_tear_summary}</Table.Cell>
              </Table.Row>}
        { this.state.liabilities.wearAndTear.map(entry =>{
          return <Table.Row>
          <Table.Cell>{entry.index}</Table.Cell>
          <Table.Cell>{entry.room}</Table.Cell>
          <Table.Cell>{entry.group}</Table.Cell>
          <Table.Cell>{entry.item.name}</Table.Cell>
          <Table.Cell>{entry.item.co_notes}</Table.Cell>
        </Table.Row>
        })}
          </Table.Body>
      </Table>
    </Segment></React.Fragment>}

    {this.state.liabilities.landlordInfo.length > 0 && <React.Fragment><Header id="LandlordInfo" className="nested-segment" as="h3" attached="top">
    <Header.Content>Liability Summary - Landlord Information <Button style={{marginLeft:"5px"}}onClick={()=> this.copyLiability("llinfo")} compact primary>Copy To Clipboard</Button><Button onClick={()=>{this.followFlag("top")}}compact basic >Back to Top</Button></Header.Content> 
    </Header>
    <Segment attached className="nested-segment">
      <Table>
        <Table.Header><Table.Row>
          <Table.HeaderCell collapsing>Ref</Table.HeaderCell>
          <Table.HeaderCell>Room</Table.HeaderCell>
          <Table.HeaderCell>Group</Table.HeaderCell>
          <Table.HeaderCell>Item </Table.HeaderCell>
          <Table.HeaderCell>Check Out Notes</Table.HeaderCell>
          </Table.Row></Table.Header>
          <Table.Body>
                       {this.props.reportDetails.additional_summary_detail && this.props.reportDetails.additional_summary_detail.landlord_items_summary && <Table.Row>
              <Table.Cell colspan={3}><strong>General Note</strong></Table.Cell>
              <Table.Cell colspan={2}>{this.props.reportDetails.additional_summary_detail.landlord_items_summary}</Table.Cell>
              </Table.Row>}
        { this.state.liabilities.landlordInfo.map(entry =>{
          return <Table.Row>
          <Table.Cell>{entry.index}</Table.Cell>
          <Table.Cell>{entry.room}</Table.Cell>
          <Table.Cell>{entry.group}</Table.Cell>
          <Table.Cell>{entry.item.name}</Table.Cell>
          <Table.Cell>{entry.item.co_notes}</Table.Cell>
        </Table.Row>
        })}
          </Table.Body>
      </Table>
    </Segment></React.Fragment>}
    </React.Fragment>}
  </React.Fragment>
    )
}
}



// WEBPACK FOOTER //
// ./src/views/report/report_viewer/report_viewer_container.js